import Vue from 'vue';
import VueI18n from 'vue-i18n';
import localeRepository from './repositories/locale-repository';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
});

export async function loadLocalesFromAPI() {
  const { locale, translations } = await localeRepository.getLocale();

  i18n.locale = locale;
  i18n.setLocaleMessage(locale, translations);
}

export async function loadDeviseLocalesFromAPI() {
  const { locale, translations } = await localeRepository.getDeviseLocale();

  i18n.locale = locale;
  i18n.setLocaleMessage(locale, translations);
}
